var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__track"}),_c('div',{staticClass:"progress-bar__fill",style:(_vm.getFillStyles)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }